<template>
  <div>
    <menu-bar active="profile"></menu-bar>
    <div class="large-8 columns content__column">
        <h2>Endre passord eller e-postadresse</h2>
        <p>Velg deg et nytt passord eller skriv inn en ny e-postadresse.</p>

        <div class="form__errors" v-if="postErrors != null">
            Det oppstod en feil ved registeringen.
            <ul>
                <template v-for="fieldErrors in postErrors">
                    <template v-for="error in fieldErrors">
                        <li>
                            {{ error }}
                        </li>
                    </template>
                </template>
            </ul>
        </div>

        <div class="row form">
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    Passord
                    <input type="password" name="password" maxlength="255" required v-model="caller.password" v-validate="'min:6'" data-vv-as="Passord" ref="password">
                    <span v-show="errors.has('password')" class="form__field__error">{{ errors.first('password') }}</span>
                </label>
            </div>
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    Gjenta passord
                    <input type="password" name="passwordConfirm" maxlength="255" required v-model="passwordConfirm" v-validate="'confirmed:password'" data-vv-as="Passord">
                    <span v-show="errors.has('passwordConfirm')" class="form__field__error">{{ errors.first('passwordConfirm') }}</span>
                </label>
            </div>
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    E-postadresse
                    <input type="text" name="email" maxlength="255" v-model="caller.email" v-validate="'min:6'" data-vv-as="E-postadresse">
                    <span v-show="errors.has('email')" class="form__field__error">{{ errors.first('email') }}</span>
                </label>
            </div>
            <p class="small-12 columns">
                <strong>NB! Vi sender ikke svar på SOS-meldinger til din e-postadresse.</strong><br>
                Du må logge deg inn hos oss for å lese svarene på SOS-meldingene dine.
            </p>
            <div class="form__submit small-12 medium-7 columns">
                <button @click.prevent="profile" class="button form__submit__button">Endre</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import MenuBar from './Menu.vue';

  export default {
    data(){
      return {
        caller: {
            password: '',
            email: '',
        },
        passwordConfirm: '',
        postErrors:null,
        }
    },
    components: {
        MenuBar
    },
    created() {
        var user = this.$auth.user();
        if(user) {
            this.caller.email = user.email;
        }
    },
    methods: {
        profile() {
            var _this = this;
            this.postErrors = null;
            this.$validator.validateAll().then(isValid => {
                if(isValid) {
                    // update profile
                    _this.$http({ method: 'post',url: '/caller/profile', data : _this.caller })
                        // success
                        .then(function (response) {
                            if(response && response.data) {

                            var user = _this.$auth.user();
                            user.email = _this.caller.email;
                            _this.$auth.user(user);

                            _this.$router.push('/');
                            }
                        })
                        // failed
                        .catch(function (error) {
                            // (error.response);
                            if(error.response && error.response.data) {
                                var data = error.response.data;
                                // console.log(data);
                                _this.postErrors = data;
                            }
                        });
                }
            });
        }
    }
  }
</script>
<style language="scss">

</style>



// WEBPACK FOOTER //
// src/components/Profile.vue